import {Organization} from 'api/types/organisationTypes';
import {ManageOrganizationActionType} from './types';

export const LOAD_ORGANIZATIONS_REQUEST =
  'ManageOrganizationPage/LOAD_ORGANIZATIONS_REQUEST';
export const LOAD_ORGANIZATIONS_SUCCESS =
  'ManageOrganizationPage/LOAD_ORGANIZATIONS_SUCCESS';
export const LOAD_ORGANIZATIONS_FAILURE =
  'ManageOrganizationPage/LOAD_ORGANIZATIONS_FAILURE';

export const ADD_ORGANIZATION_REQUEST =
  'ManageOrganizationPage/ADD_ORGANIZATION_REQUEST';
export const ADD_ORGANIZATION_SUCCESS =
  'ManageOrganizationPage/ADD_ORGANIZATION_SUCCESS';
export const ADD_ORGANIZATION_FAILURE =
  'ManageOrganizationPage/ADD_ORGANIZATION_FAILURE';

export const EDIT_ORGANIZATION_REQUEST =
  'ManageOrganizationPage/EDIT_ORGANIZATION_REQUEST';
export const EDIT_ORGANIZATION_SUCCESS =
  'ManageOrganizationPage/EDIT_ORGANIZATION_SUCCESS';
export const EDIT_ORGANIZATION_FAILURE =
  'ManageOrganizationPage/EDIT_ORGANIZATION_FAILURE';

export const DELETE_ORGANIZATION_REQUEST =
  'ManageOrganizationPage/DELETE_ORGANIZATION_REQUEST';
export const DELETE_ORGANIZATION_SUCCESS =
  'ManageOrganizationPage/DELETE_ORGANIZATION_SUCCESS';
export const DELETE_ORGANIZATION_FAILURE =
  'ManageOrganizationPage/DELETE_ORGANIZATION_FAILURE';

export const DOWNLOAD_RESULTS_REQUEST =
  'ManagerOrganizationPage/DOWNLOAD_RESULTS_REQUEST';
export const DOWNLOAD_RESULTS_SUCCESS =
  'ManagerOrganizationPage/DOWNLOAD_RESULTS_SUCCESS';
export const DOWNLOAD_RESULTS_FAILURE =
  'ManagerOrganizationPage/DOWNLOAD_RESULTS_FAILURE';

export function loadOrganizationsRequest(): ManageOrganizationActionType {
  return {
    type: LOAD_ORGANIZATIONS_REQUEST,
    payload: {},
  };
}

export function loadOrganizationsSuccess(
  data: Organization[]
): ManageOrganizationActionType {
  return {
    type: LOAD_ORGANIZATIONS_SUCCESS,
    payload: {
      data,
    },
  };
}

export function loadOrganizationsFailure(
  error: Error
): ManageOrganizationActionType {
  return {
    type: LOAD_ORGANIZATIONS_FAILURE,
    payload: {
      error,
    },
  };
}

export function addOrganizationRequest(): ManageOrganizationActionType {
  return {
    type: ADD_ORGANIZATION_REQUEST,
    payload: {},
  };
}

export function addOrganizationSuccess(
  user: Organization
): ManageOrganizationActionType {
  return {
    type: ADD_ORGANIZATION_SUCCESS,
    payload: {
      selectedOrganization: user,
    },
  };
}

export function addOrganizationFailure(
  error: Error
): ManageOrganizationActionType {
  return {
    type: ADD_ORGANIZATION_FAILURE,
    payload: {
      error,
    },
  };
}

export function editOrganizationRequest(): ManageOrganizationActionType {
  return {
    type: EDIT_ORGANIZATION_REQUEST,
    payload: {},
  };
}

export function editOrganizationSuccess(
  user: Organization
): ManageOrganizationActionType {
  return {
    type: EDIT_ORGANIZATION_SUCCESS,
    payload: {
      selectedOrganization: user,
    },
  };
}

export function editOrganizationFailure(
  error: Error
): ManageOrganizationActionType {
  return {
    type: EDIT_ORGANIZATION_FAILURE,
    payload: {
      error,
    },
  };
}

export function deleteOrganizationRequest(): ManageOrganizationActionType {
  return {
    type: DELETE_ORGANIZATION_REQUEST,
    payload: {},
  };
}

export function deleteOrganizationSuccess(
  selectedOrganization: Organization
): ManageOrganizationActionType {
  return {
    type: DELETE_ORGANIZATION_SUCCESS,
    payload: {
      selectedOrganization,
    },
  };
}

export function deleteOrganizationFailure(
  error: Error
): ManageOrganizationActionType {
  return {
    type: DELETE_ORGANIZATION_FAILURE,
    payload: {
      error,
    },
  };
}

export function downloadResultsRequest(): ManageOrganizationActionType {
  return {
    type: DOWNLOAD_RESULTS_REQUEST,
    payload: {},
  };
}

export function downloadResultsSuccess(): ManageOrganizationActionType {
  return {
    type: DOWNLOAD_RESULTS_SUCCESS,
    payload: {},
  };
}

export function downloadResultsFailure(
  error: Error
): ManageOrganizationActionType {
  return {
    type: DOWNLOAD_RESULTS_FAILURE,
    payload: {
      error,
    },
  };
}
